import React from 'react';
import logo from '../logo.jpg'
import { gql, useQuery } from "@apollo/client";
import html2pdf from 'html2pdf.js';
import '../App.css';

const GET_PEDIDOS = gql`
  query getPedidos {
    getPedidos {
      _id
      estado
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

function GenerarPDF() {
  const { loading, error, data } = useQuery(GET_PEDIDOS);

  if (loading) return <p>Esperando resultados...</p>;
  if (error) return <p>Error</p>;

  console.log(data);

  const generarPDF = (pedido) => {
    const contenidoDiv = document.createElement('div');
    contenidoDiv.innerHTML = `
    <div class="container pdf">
    </br>
    </br>
    <div class="row">
    
      <div class="col">
      <img src=${logo} width="100" height="100"  alt="" />
      <p>3226140639</p>
      <p>Calle 11 #7-35</p>
      <p>www.fruve.co</p>
      
     
      </div>
      <div class="col ">
      </br>
      <div class="encabezado"><p >Número de pedido:  00${pedido.numeroPedido}</p></div>
      
      <p>Cliente:  ${pedido.nombreCliente}</p>
      <p>Dirección:  ${pedido.direccionCliente}</p>
      <p>Contacto:  ${pedido.whatsappCliente}</p>
      <p>Nota del Pedido:  ${pedido.notaPedido}</p>
      
      
      
     
      
      </div>
      <div class="container ">
  <div class="row barra-pdf">
    <div class="col-4">
      Producto
    </div>
    <div class="col-2">
      Cantidad
    </div>
    <div class="col-3">
      Precio unitario
    </div>
    <div class="col-3">
    Subtotal
  </div>
  </div>
</div>
      <ul>
          ${pedido.productos && JSON.parse(pedido.productos).map((producto) => (
            `
            <div class="container  ">
            <div class="row">
              <div class="col-4">
              ${producto.nombre}
              </div>
              <div class="col-2">
              ${producto.cantidad}
              </div>
              <div class="col-3">
              ${producto.precio}
              </div>
              <div class="col-3">
              ${producto.cantidad * producto.precio}
            </div>
            </div>
          </div>
            `
          )).join('')}
        </ul>
  </div>

    `;

    html2pdf().from(contenidoDiv).save(`pedido_${pedido.numeroPedido}.pdf`);
  };

  return (
    <div className="row">
      {data.getPedidos.map((pedido) => (
        <div key={pedido._id}>

<div class="card card-salida col-xs-12 col-xl-4 col-sm-6">
<div class="card-body">
<h1>Número de Pedido: {pedido.numeroPedido}</h1>
          <h2>Estado: {pedido.estado}</h2>
          <p>Nombre del Cliente: {pedido.nombreCliente}</p>
          <p>Dirección del Cliente: {pedido.direccionCliente}</p>
          <p>WhatsApp del Cliente: {pedido.whatsappCliente}</p>
          <p>Nota del Pedido: {pedido.notaPedido}</p>
          <h3>Productos:</h3>
          <ul>
            {pedido.productos && JSON.parse(pedido.productos).map((producto, index) => (
              <li key={index}>{producto.nombre} - {producto.precio}</li>
            ))}
          </ul>
          <button className='btn btn-success' onClick={() => generarPDF(pedido)}>Descargar pdf</button>
      
</div>
</div>
         
         </div>
      ))}
    </div>
  );
}

export default GenerarPDF;
